module.exports = __webpack_public_path__ + "static/media/endosso.cc7c75c8.png";